import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const ContentFilters = styled.div`
  display: none;
  gap: 5px;
  padding: 10px 16px;

  & > label {
    width: 176px;
    padding: 10px 8px;
    height: inherit;
    margin-bottom: 0;
    gap: 7px;

    & > svg {
      min-height: 12px;
      min-width: 12px;
      margin: 0;

      &:first-child {
        margin: 0;
      }
    }

    & select {
      margin: 0;
      font-size: 12px;
      line-height: 19px;
    }
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const LoadingSpin = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    min-height: 30px;
    min-width: 30px;
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const HeaderTitle = styled.span`
  font-size: 16px;
  line-height: 25px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.blue};
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${({ theme }) => theme.colors.blue};

  & > svg {
    min-width: 14px;
    min-height: 14px;
    cursor: pointer;
  }

  & > label {
    width: 176px;
    padding: 10px 8px;
    height: inherit;
    margin-bottom: 0;
    gap: 7px;

    & > svg {
      min-height: 12px;
      min-width: 12px;
      margin: 0;

      &:first-child {
        margin: 0;
      }
    }

    & select {
      margin: 0;
      font-size: 12px;
      line-height: 19px;
    }
  }

  @media (max-width: 768px) {
    & label {
      display: none;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 286px;

  @media (max-width: 768px) {
    max-height: 425px;
  }
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  &:last-of-type {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    align-items: start;
    gap: 5px;
  }
`;

export const ContentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const ContentLabel = styled.div`
  display: flex;
  flex-direction: column;

  &:nth-child(1) {
    width: 33%;
  }
  &:nth-child(2) {
    width: 33%;
  }
  &:nth-child(3) {
    width: 33%;
  }
  /* &:nth-child(4) {
    width: 22%;
  } */

  @media (max-width: 768px) {
    &:nth-child(1) {
      width: 54%;
    }
    &:nth-child(2) {
      width: 40%;
    }
    &:nth-child(3) {
      width: 54%;
    }
    &:nth-child(4) {
      width: 40%;
    }
  }
`;

export const Label = styled.span`
  font-size: 12px;
  line-height: 19px;
  font-family: 'Mangueira Bold';
  color: ${({ theme }) => theme.colors.blue};
`;

export const Value = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: #828282;

  display: flex;
  align-items: center;
  gap: 5px;
`;

export const Options = styled.div`
  min-width: 16px;

  & > svg {
    min-height: 16px;
    min-width: 16px;
    color: ${({ theme }) => theme.colors.blue};
  }
`;

type StatusProps = {
  status: string;
};

export const Status = styled.div<StatusProps>`
  min-height: 7px;
  min-width: 7px;
  border-radius: 100%;

  background-color: ${({ status }) => {
    switch (status) {
      case 'em-analise':
      case 'os-em-analise':
      case 'os-em-atendimento':
      case 'reprogramado':
      case 'agendado':
        return '#F8C953';
      case 'confirmado':
      case 'em-rota':
        return '#00efff';
      case 'realizado':
      case 'atendido':
      case 'os-finalizada':
        return '#40BC61';
      case 'cancelado':
      case 'nao-atendido':
      case 'os-cancelada':
        return '#EC4D2C';
      default:
        return '';
    }
  }};
`;

export const TooltipIcon = styled.div`
  > svg {
    color: #00efff;
    min-height: 14px;
    min-width: 14px;
    cursor: pointer;
  }
`;
